import { Widget } from "./widget.class";
import { InvestmentTypeHierarchy } from "./investment-type-hierarchy.class";
import { KeyValuePair } from "./key-value-pair.class";
import { AggregatedPortfolioSeries } from "./aggregated-portfolio-series.class";
import { Portfolio } from "./portfolio.class";
import { AssetDealsDetails } from "./asset.class";

export class PortfolioSeriesDashboard {
    summary!: AggregatedPortfolioSeries;
    widgets!: Record<Widget, KeyValuePair<string|number, number>[]>;
    displayPortfolioDetail!: Portfolio;
    investmentTypes!: Record<number, InvestmentTypeHierarchy[]>;
    portfolioSeriesMasterId!: number;
    isLiquidated!: boolean;
    otherSectorNames!: string[];
    otherCountryNames!: string[];
    assetDeals!: AssetDealsDetails[];
}
